// config.joanoro.js
  /*
  Institut Joan Oró
  Martorell
  Laura Corominas

  ESO
      1r curs
      2n curs
      3r curs
      4t curs

  Batxillerat
      Batxillerat Artístic
      Batxillerat d'Humanitats i Ciències Socials
      Batxillerat Científic i Tecnològic

  Cicles


  Particularitats:
  
  TORNS + NESE B ** 
  carnetFamiliaNombrosaFile **
  autoritzacio AuthValEscolar **

  notesAccesFile


  authIntranet
  authPublicacions
  authMaterial
  authMaterialInicials
  authInternet
  authCompromis
  authGDPR
  authDretsImatge
  authSortides
  authAMPA
  authMedica
  authParacetamol
  authReligio
  authAbsentisme
  authAlternanca
  authResponsable
  authValEscolar

  */

const config =
{
    cid: 'a8037152',

    // llistat dels camps d'autorització del pas "Protecció de dades" d'aquest centre
    // (veure src/components/enrolmentform/authorizations/joanoro/)
    autoritzacions: [
        'authAbsentisme', 'authAlternanca', 'authAMPA', 'authCompromis', 'authDretsImatge',
        'authGDPR', 'authGimnas', 'authInternet', 'authIntranet', 'authMaterial',
        'authMaterialInicials', 'authMedica', 'authParacetamol', 'authPublicacions',
        'authReligio', 'authResponsable', 'authSortides', 'authValEscolar',
    ],

    phone: "93 775 36 18",
    email: "a8037152@xtec.cat",

    headerLogo:  'img/logo_bn_joanoro.png',
    headerTitle:  'Institut Joan Oró',
    headerURL: 'https://matricula.institutjoanoro.cat/',

    //enrollmentPostURL: 'https://matricula.institutjoanoro.cat/post/',
    enrollmentPostURL: '/post/',
    //apiURL: 'https://matricula.institutjoanoro.cat/api/',
    apiURL: '/api/',

    popupInicial: false,

  /* valor per defecte (mandatori); es pot sobreescriure per curs concret amb
       curs.adjuntarArxiusNoObligatori a les dades de families (chkiddoc + cursObligatori);
       aquest valor només s'aplica a la matrícula lliure, sense curs obligatori */
    adjuntarArxiusNoObligatori: false,

    // llibre de família (plana progenitors + plana alumne) obligatori per als menors d'edat
    llibreFamiliaObligatori: true,

    validaIDdocuments: true,  
    tipusDocTSI: true,
    tipusDocPreInscripcio: true,

    fotoCarnet: true,
    validaIAfotoCarnetFile: true,
    validaIAiddocumentFrontFile: false,


    telefonObligatori: false,
    carnetFamiliaNombrosa: true,

    contacteEmergenciaObligatori: false,

    adjuntMedic: false,
    adjuntMedicObligatori: false,

    datesNoBloquejenInscripcio: false,

    noPreguntarSiEsNouAlumne: false,

    notesAcces: true,

    mostraTorns: true,

    logo: 'img/logo_joanoro.jpg',
    titol: 'IES Joan Oro',

    favicon: '/img/favicon-joanoro.ico',
    faviconGestio: '/gestio/img/favicon-joanoro.ico',

    assignatures: 'assignatures/assignatures.joanoro.json',
    families: 'families/families.joanoro.json',
    dadesbancaries: 'dadesbancaries/dadesbancaries.joanoro.json',
    calculquota: 'quotes.joanoro.json',

    textNESEB: "El teu fill/a ha rebut l’ajut de la Motxilla Escolar. L’objecte d’aquest ajut és l'assignació de recursos econòmics als centres, que tenen matriculat per al curs 2026-2027 alumnat NESE B.Generalitat de Catalunya​ Departament d’Educació ​ i Formació Professional Institut Joan Oró.<br/> Els imports que els centres rebran en relació amb le​s motxilles de l’alumnat, en el cas dels centres públics van destinats a: <ul><li>Quota de material escolar</li> <li> Sortides i colònies</li> </ul> <p> Per tant, no és necessari pagar la quota de material ni despeses derivades d’activitats pedagògiques del centre. En relació als llibres, el centre, els facilitarà a l’alumnat a l’inici de curs. </p> ",

    /* camps especifics per centre */
    treballantFile: true,
    necessitatsEducativesEspecials: true,

    repetidor: false,
    repetidorsNoPodenAgafarAssignaturesDe2n: false,

    textDadesMediquesAlgunSi: "",

    textBotoMatricular: "INSCRIURE",

    proporcionarPreinscripcioNous: (new Date().getMonth() >= 4 && new Date().getMonth() <= 7),// SETEMBRE en endavant no cal
    proporcionarTitolPreinscripcioNous: true,
    comprovantAcceptacioPlaca: (new Date().getMonth() >= 4 && new Date().getMonth() <= 7), // SETEMBRE en endavant no cal

    textProporcionarPreinscripcioNous: (new Date().getMonth() >= 4 && new Date().getMonth() <= 7) ? 
                                  "Cal proporcionar número de preinscripció, adjuntar títol pel qual s'accedeix i el comprovant d'acceptació de plaça per poder proseguir amb la <b>matrícula de CFGM i CFGS. Per a la resta d'estudis no és obligatori.</b>." 
                                  : "Cal adjuntar títol pel qual s'accedeix per poder proseguir amb la <b>matrícula de CFGM i CFGS. Per a la resta d'estudis no és obligatori.</b>.",

    textAlumneNouAlCentre: "Ets alumne nou als estudis que et matricules?",
    textAlumneNouAlCentreSub: "(Si has fet una preinscripció per Internet per a aquest curs, marca SÍ, per la resta de casos cal indicar NO)",

    urlTPV: "https://matricula.institutjoanoro.cat/tpv/",
    pagamentTPV: true,
    pagamentTransferencia: false,

   /* el pagament en dos terminis només està habilitat durant el primer periòde de matriculacions */
   dosTerminisEnabled: (new Date().getMonth() >= 4 && new Date().getMonth() <= 7),
   /* si es fals mostrem unes altres condicions de pagament */
   dosTerminisEnabledFalseCondicio: 0,

    sexeNoBinari: false,

    pattern_batx_nocturn: /^BATXLOE\d{5}N[A-Z]{1,2}$/,
    pattern_1r_batx: /^BATXLOE\d{4}1[^N][A-Z]{1,2}$/,
    pattern_2n_batx: /^BATXLOE\d{4}2[^N][A-Z]{1,2}$/,

    su: ['WyIxMTExMTEx', 'MUgiLCIyMjIyMjIyM', 'koiLCI0NTQ5MjQwNVMiXQ=='],
  };

export default  config;
